module.exports = __webpack_public_path__ + "static/media/conversion_2_gray.1dd62fb3.png";